export enum TransportationType {
  Pickup = 1,
  Drop = 2,
  Both = 3
}
